import { render, staticRenderFns } from "./DeclareImport.vue?vue&type=template&id=7711f8b6&scoped=true&"
import script from "./DeclareImport.vue?vue&type=script&lang=js&"
export * from "./DeclareImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7711f8b6",
  null
  
)

export default component.exports